import React, { Component } from 'react';
import { translate } from 'react-i18next';
import _ from 'underscore';
import ChallengeService from '../../services/ChallengeService.js';
import { connect } from 'react-redux';
import Utils from '../../utils/Utils.js';
import Rewards from './Rewards.js';
import {fetchRewards, redeemReward} from 'actions/rewards.js';
import {getRewards} from 'reducers/rewards.js';
import {getUserProfileWithDefaults} from 'reducers/user.js';
import {SET_LOADING_OVERLAY_ENABLE} from 'actions/types';
import {initNavbarState} from 'actions/navbar.js';
import {getFeaturePluginSetting} from 'reducers/features.js';

class RewardsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false, redeemResult:null};
        this.claimButtonDisable = this.claimButtonDisable.bind(this);
        this.onRedeemReward = this.onRedeemReward.bind(this);
        this.onHideModal = this.onHideModal.bind(this);

        console.log('RewardsContainer: ', this);
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, mode:'main', title:this.props.t('Rewards'), menuEnable:true, backButtonEnable:false, rewardsEnable:true}));
        this.loadData();
    }

    loadData() {
        this.setState({busy:true});
        this.props.loadData()
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }

    claimButtonDisable(reward){
        var userResources = Utils.deref(this.props,'userProfile.resources',0);
        var resourceLimit = userResources;
        if(this.props.monthlyClaimsLimit!==null) {
            var monthlyClaimsLimit = this.props.monthlyClaimsLimit;
            if(this.props.monthlyClaims!==null) {
                var adjustedClaimsLimit = Math.max(0, monthlyClaimsLimit - this.props.monthlyClaims);
                if (reward.price > (adjustedClaimsLimit*100)) {
                    return true;
                }
            }
        }

        if( resourceLimit >= reward.resources ) {
           return false;
        } else {
           return true;
        }
    }

    onRedeemReward(reward) {

        this.props.dispatch({type:SET_LOADING_OVERLAY_ENABLE, enable:true});
        var success = true;
        this.props.redeemReward(reward.id)
                    .catch((error)=>{
                        success = false;
                        console.error("error - redeemReward", error);
                    })
                    .then(()=>{
                        this.setState({redeemResult:{reward, success}});
                        this.props.dispatch({type:SET_LOADING_OVERLAY_ENABLE, enable:false});
                    });
    }

    onHideModal() {
        this.setState({redeemResult:null});
    }


    render() {
        return <Rewards rewards={this.props.rewards} 
                        busy={this.state.busy}
                        monthlyClaimsLimit={this.props.monthlyClaimsLimit}
                        monthlyClaims={this.props.monthlyClaims}
                        claimButtonDisable={this.claimButtonDisable}
                        onRedeemReward={this.onRedeemReward}
                        redeemResult={this.state.redeemResult}
                        onHideModal={this.onHideModal}
                        imageError={this.imageError}/>;
    }

}


function getMonthlyClaimsLimit(features, userProfile) {
    var monthlyClaimLimit = getFeaturePluginSetting(features, 'rewards', 'claimsLimit')
    if(monthlyClaimLimit !== undefined) {
        return monthlyClaimLimit/100.0;
    }
    return null;
}
function getMonthlyClaims(userProfile) {
    if(userProfile && _.isFinite(userProfile.claims)) {
        return userProfile.claims/100.0;
    }
    return null;
}

const mapStateToProps = (state, ownProps) => {
    var userProfile = getUserProfileWithDefaults(state.user);
    var monthlyClaims = getMonthlyClaims(userProfile);
    var monthlyClaimsLimit = getMonthlyClaimsLimit(state.features, userProfile);
    return {rewards:getRewards(state.rewards), userProfile, monthlyClaims, monthlyClaimsLimit};
};
const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(fetchRewards()),
        redeemReward: (id) => dispatch(redeemReward(id)),
        dispatch: dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate('rewards')(RewardsContainer));



// WEBPACK FOOTER //
// ./src/modules/rewards/RewardsContainer.js